import { atom } from 'jotai';

const zipCodeFromUserErrorAtom = atom(null);

export default zipCodeFromUserErrorAtom;
